import React, { useState } from "react";
import {
  Grid,
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { DATA } from "./Data";
import { size, COLORS } from "../../utils";
import PatchIcon from "../../assets/icons/patch";
import Apply from "./Apply";

export default function Career() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const is1536 = useMediaQuery("(max-width:1536px)");

  const Data = [DATA.slice(0, 2), DATA.slice(2, 4)];
  const [open, setOpen] = useState(false);
  const [applyData, setApplyData] = useState({});

  return (
    <Grid
      item
      container
      flexWrap={"nowrap"}
      direction={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      width={size({ p: 100 })}
      rowGap={size({ p: 8, h: true })}
      marginTop={isMobile ? size({ p: 3, h: true }) : size({ p: 2, h: true })}
      marginBottom={size({ p: 2, h: true })}
    >
      <Grid
        item
        container
        flexWrap={"nowrap"}
        direction={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        rowGap={size({ p: 1, h: true })}
      >
        <Grid item>
          <Typography
            sx={{
              fontFamily: "Archia",
              fontSize: isMobile ? "1.4rem" : size({ p: 3 }),
              fontWeight: 700,
              textAlign: "left",
              color: COLORS.C2,
              marginTop: isMobile ? "0.8rem" : "",
            }}
          >
            Career Oppurtunities
          </Typography>
        </Grid>

        <Grid item>
          <Typography
            id={"career_ops"}
            sx={{
              fontFamily: "Archia",
              fontSize: isMobile ? "0.8rem" : size({ p: 1 }),
              fontWeight: 400,
              textAlign: "center",
              color: `${COLORS.C1}A0`,
              padding: isMobile
                ? `0px ${size({ p: 10 })}`
                : `0px ${size({ p: 25 })}`,
            }}
          >
            Join us. Innovate with us. Shape the future with us.
          </Typography>
        </Grid>
      </Grid>

      {Data.map((k) => {
        return (
          <Grid
            item
            container
            alignItems={"center"}
            justifyContent={"center"}
            width={size({ p: 100 })}
            columnGap={isMobile ? size({ p: 3 }) : size({ p: 5 })}
            mt={isMobile ? "-2.5rem" : ""}
          >
            {k.map((dat, i) => {
              return (
                <Box position={"relative"}>
                  <Box
                    sx={{
                      zIndex: 1,
                      width: isMobile
                        ? size({ p: 43 })
                        : is1536
                        ? size({ p: 28 }) // **1440 responsive change**
                        : size({ p: 25 }),
                      height: isMobile
                        ? size({ p: 52, h: true })
                        : is1536
                        ? size({ p: 36 })
                        : size({ p: 70, h: true }),
                      position: "absolute",
                      top: size({ p: 2, h: true }),
                      right: i === 0 ? size({ p: 1 }) : "auto",
                      left: i === 1 ? size({ p: 1 }) : "auto",
                      backgroundColor: dat.bgcolor,
                      border: `${size({ p: 0.1 })} solid ${COLORS.BLACK}`,
                      borderRadius: size({ p: 0.6 }),
                    }}
                  />

                  <Box
                    sx={{
                      zIndex: 2,
                      width: isMobile
                        ? size({ p: 43 })
                        : is1536
                        ? size({ p: 28 }) // **1440 responsive**
                        : size({ p: 25 }),
                      height: isMobile
                        ? size({ p: 53, h: true })
                        : is1536
                        ? size({ p: 36 })
                        : size({ p: 70, h: true }),
                      position: "relative",
                      backgroundColor: dat.bgcolor.slice(0, 7),
                      border: `${size({ p: 0.1 })} solid ${COLORS.BLACK}`,
                      borderRadius: size({ p: 0.6 }),
                      padding: `${size({ p: 2, h: true })} ${size({ p: 1.5 })}`,
                      paddingTop: "1.5rem",
                    }}
                  >
                    <Grid
                      item
                      container
                      flexWrap={"nowrap"}
                      direction={"column"}
                      rowGap={size({ p: 1.5, h: true })}
                    >
                      <Grid item>
                        <Typography
                          sx={{
                            fontFamily: "Space Mono",
                            fontSize: isMobile
                              ? size({ p: 2.5 })
                              : size({ p: 1.2 }),
                            fontWeight: 700,
                            backgroundColor: COLORS.C2,
                            color: COLORS.WHITE,
                            padding: `${size({ p: 0.5, h: true })} ${size({
                              p: 1,
                            })}`,
                            borderRadius: size({ p: 0.3 }),
                            display: "inline-block",
                          }}
                        >
                          {dat.Title}
                        </Typography>
                      </Grid>

                      <Grid item>
                        <Typography
                          sx={{
                            fontFamily: "Space Mono",
                            fontSize: isMobile
                              ? size({ p: 2 })
                              : size({ p: 0.9 }),
                            color: COLORS.BLACK + "E0",
                          }}
                        >
                          {dat.BasicDescription}
                        </Typography>
                      </Grid>

                      <Grid
                        item
                        container
                        flexWrap={"nowrap"}
                        direction={"column"}
                        width={size({ p: 25 })}
                        pt={size({ p: 0.8, h: true })}
                      >
                        <Grid item>
                          <Typography
                            sx={{
                              fontFamily: "Space Mono",
                              fontSize: isMobile
                                ? size({ p: 2 })
                                : size({ p: 1 }),
                              fontWeight: 700,
                              color: COLORS.BLACK + "E0",
                            }}
                          >
                            Skills Required
                          </Typography>
                        </Grid>

                        <Grid item>
                          <List>
                            {dat.Skills.map((p, i) => {
                              return (
                                <ListItem
                                  disablePadding
                                  key={`skills_data_${i}`}
                                  sx={{
                                    padding: `${size({ p: 0.1 })} 0px ${size({
                                      p: 0.1,
                                    })} 0px`,
                                  }}
                                >
                                  <ListItemIcon
                                    sx={{
                                      minWidth: 0,
                                    }}
                                  >
                                    <PatchIcon
                                      fill={COLORS.BLACK + "A0"}
                                      width={size({ p: 1 })}
                                      height={size({ p: 1 })}
                                    />
                                  </ListItemIcon>
                                  <ListItemText>
                                    <Typography
                                      sx={{
                                        fontFamily: "Space Mono",
                                        fontSize: isMobile
                                          ? size({ p: 1.7 })
                                          : size({ p: 0.8 }),
                                        fontWeight: 400,
                                        color: COLORS.BLACK + "A0",
                                        paddingLeft: size({ p: 0.5 }),
                                        width: isMobile
                                          ? size({ p: 31 })
                                          : size({ p: 20 }),
                                      }}
                                    >
                                      {p}
                                    </Typography>
                                  </ListItemText>
                                </ListItem>
                              );
                            })}
                          </List>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        sx={{
                          display: "flex",
                          alignItems: "flex-end",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          variant="contained"
                          onClick={() => {
                            setApplyData(dat);
                            setOpen(true);
                          }}
                          sx={{
                            backgroundColor: `${COLORS.C1}`,
                            fontFamily: "Space Mono",
                            fontWeight: 400,
                            fontSize: isMobile
                              ? size({ p: 1.8 })
                              : size({ p: 0.8 }),
                            px: isMobile ? "7px" : "",
                            py: isMobile ? "5px" : "",
                            textTransform: "none",
                            ":hover": {
                              backgroundColor: `${COLORS.C1}`,
                            },
                          }}
                        >
                          {"Apply Now ->"}
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              );
            })}
          </Grid>
        );
      })}
      <Apply onClose={() => setOpen(false)} data={applyData} open={open} />
    </Grid>
  );
}
